import { memo } from 'react';
import { Button } from '@/hen-ui/atomics/Button';

type ExpandCollapseFooterProps = {
  expanded: boolean;
  modalOpen?: boolean;
  onExpandedChange?: (value: boolean) => void;
  onModalOpenChange?: (value: boolean) => void;
};

export const ExpandCollapseFooter = memo(function ExpandCollapseFooter({
  expanded,
  modalOpen = false,
  onExpandedChange,
  onModalOpenChange,
}: ExpandCollapseFooterProps) {
  const expandLabel = expanded ? 'Collapse Details' : 'Expand Details';

  return (
    <>
      {/* Desktop: inline expand/collapse */}
      <Button
        variant='textOnly'
        size='flush'
        iconBefore={expanded ? 'chevron-up' : 'chevron-down'}
        onClick={() => onExpandedChange?.(!expanded)}
        className='hidden md:inline-flex text-primary-700 font-bold'
        aria-expanded={expanded}
      >
        {expandLabel}
      </Button>

      {/* Mobile: open modal */}
      <Button
        variant='textOnly'
        size='flush'
        iconBefore='chevron-down'
        onClick={() => onModalOpenChange?.(true)}
        className='md:hidden text-primary-700 font-bold text-l1'
        aria-haspopup='dialog'
        aria-expanded={modalOpen}
      >
        {expandLabel}
      </Button>
    </>
  );
});
